(function ($) {
  /**
   * Class Loadmore.
   */
  class LoadMore {
    /**
     * Contructor.
     */
    constructor() {
      this.ajaxUrl = siteConfig?.ajaxUrl ?? "";
      this.ajaxNonce = siteConfig?.ajax_nonce ?? "";
      this.loadMoreBtn = $("#load-more");
      this.loadingTextEl = $("#loading-text");
      this.isRequestProcessing = false;

      this.options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0, // 1.0 means set isIntersecting to true when element comes in 100% view.
      };

      this.init();
    }

    init() {
      if (!this.loadMoreBtn.length) {
        return;
      }

      // Get total pages from pagination element or set a high number as fallback
      this.totalPagesCount = $("#post-pagination").data("max-pages") || 999;

      this.loadMoreBtn.on("click", () => {
        this.handleLoadMorePosts();
      });

      /**
       * Add the IntersectionObserver api, and listen to the load more intersection status.
       * so that intersectionObserverCallback gets called if the element intersection status changes.
       *
       * @type {IntersectionObserver}
       */
      // const observer = new IntersectionObserver(
      //   (entries) => this.intersectionObserverCallback(entries),
      //   this.options
      // );
      // observer.observe(this.loadMoreBtn[0]);
    }

    /**
     * Gets called on initial render with status 'isIntersecting' as false and then
     * everytime element intersection status changes.
     *
     * @param {array} entries No of elements under observation.
     *
     */
    intersectionObserverCallback(entries) {
      // array of observing elements

      // The logic is apply for each entry ( in this case it's just one loadmore button )
      entries.forEach((entry) => {
        // If load more button in view.
        if (entry?.isIntersecting) {
          this.handleLoadMorePosts();
        }
      });
    }

    /**
     * Load more posts.
     *
     * 1.Make an ajax request, by incrementing the page no. by one on each request.
     * 2.Append new/more posts to the existing content.
     * 3.If the response is 0 ( which means no more posts available ), remove the load-more button from DOM.
     * Once the load-more button gets removed, the IntersectionObserverAPI callback will not be triggered, which means
     * there will be no further ajax request since there won't be any more posts available.
     *
     * @return null
     */
    handleLoadMorePosts() {
      // Get page no from data attribute of load-more button.
      const page = this.loadMoreBtn.data("page");
      if (!page || this.isRequestProcessing) {
        return null;
      }

      const nextPage = parseInt(page) + 1; // Increment page count by one.
      this.isRequestProcessing = true;

      // Add loading class to the button
      this.loadMoreBtn.addClass("loading");

      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          page: page,
          action: "load_more",
          ajax_nonce: this.ajaxNonce,
        },
        cache: false, // Prevent caching issues
        success: (response) => {
          // Check if response is empty or contains no posts
          if (!response || response.trim() === "0" || response.trim() === "") {
            this.loadMoreBtn.remove();
            return;
          }

          this.loadMoreBtn.data("page", nextPage);
          $("#load-more-content").append(response);
          this.removeLoadMoreIfOnLastPage(nextPage);
        },
        error: (response) => {
          console.log("Load more error:", response);

          // Check if it's a nonce error and try to refresh
          if (
            response.status === 400 ||
            (response.responseJSON &&
              response.responseJSON.data &&
              response.responseJSON.data.includes("Invalid security token"))
          ) {
            // Try to refresh nonce and retry once
            this.refreshNonceAndRetry(page);
          } else {
            // Show user-friendly error message
            this.loadMoreBtn.find("span").text("Error loading posts");
            setTimeout(() => {
              this.loadMoreBtn.find("span").text("Load More");
            }, 3000);
          }
        },
        complete: () => {
          // Remove loading class from the button
          this.loadMoreBtn.removeClass("loading");
          this.isRequestProcessing = false;
        },
      });
    }

    /**
     * Remove Load more Button If on last page.
     *
     * @param {int} nextPage New Page.
     */
    removeLoadMoreIfOnLastPage(nextPage) {
      if (nextPage + 1 > this.totalPagesCount) {
        this.loadMoreBtn.remove();
      }
    }

    /**
     * Refresh nonce and retry the request once
     *
     * @param {int} page Current page number
     */
    refreshNonceAndRetry(page) {
      // Try to get a fresh nonce
      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          action: "get_loadmore_nonce",
        },
        success: (response) => {
          if (response.success && response.data.nonce) {
            this.ajaxNonce = response.data.nonce;
            // Retry the original request once
            this.retryLoadMore(page);
          } else {
            this.showError();
          }
        },
        error: () => {
          this.showError();
        },
      });
    }

    /**
     * Retry load more with fresh nonce
     *
     * @param {int} page Current page number
     */
    retryLoadMore(page) {
      const nextPage = parseInt(page) + 1;

      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          page: page,
          action: "load_more",
          ajax_nonce: this.ajaxNonce,
        },
        cache: false,
        success: (response) => {
          if (!response || response.trim() === "0" || response.trim() === "") {
            this.loadMoreBtn.remove();
            return;
          }

          this.loadMoreBtn.data("page", nextPage);
          $("#load-more-content").append(response);
          this.removeLoadMoreIfOnLastPage(nextPage);
        },
        error: () => {
          this.showError();
        },
        complete: () => {
          this.loadMoreBtn.removeClass("loading");
          this.isRequestProcessing = false;
        },
      });
    }

    /**
     * Show error message
     */
    showError() {
      this.loadMoreBtn.find("span").text("Error loading posts");
      setTimeout(() => {
        this.loadMoreBtn.find("span").text("Load More");
      }, 3000);
    }
  }

  new LoadMore();
})(jQuery);
